import type {SVGProps} from 'react';
import {forwardRef} from 'react';

type Props = SVGProps<SVGSVGElement> & {
    title?: string;
};

export const StarIcon = forwardRef<SVGSVGElement, Props>(({title, ...rest}, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentColor' {...rest} ref={ref}>
        <path d='m8 3.76.945 2.225.274.646.7.06 2.412.208-1.835 1.59-.532.461.16.686.549 2.355-2.071-1.25L8 10.377l-.602.364-2.075 1.253.547-2.36.159-.684-.53-.46L3.665 6.9l2.417-.21.7-.06.273-.645.945-2.225Zm0-2.428a.354.354 0 0 0-.328.218l-1.69 3.978-4.322.373a.357.357 0 0 0-.203.626L4.733 9.37l-.98 4.225c-.055.24.135.44.349.44a.358.358 0 0 0 .184-.053L8 11.74l3.713 2.24a.358.358 0 0 0 .533-.387l-.985-4.222 3.283-2.843a.357.357 0 0 0-.204-.626l-4.321-.373L8.33 1.55A.353.353 0 0 0 8 1.332Z' />
        {title && <title>{title}</title>}
    </svg>
));
